import React from "react";
import { useHistory } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Menu } from "@arco-design/web-react";
import { IconFile } from "@arco-design/web-react/icon";
import { ConsoleList } from "@/config/data";
import UserKeyManager from "./components/UserKeyManager";
import "./style.less";

const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;

const ConsolePage: React.FC = () => {
	const history = useHistory();

	const handleLoginClick = () => {
		history.push("/login");
	};

	return (
		<div className="console-container">
			<div className="console-header">
				<Navbar onLoginClick={handleLoginClick} />
			</div>

			<div className="console-layout">
				<div className="console-sidebar">
					<Menu
						style={{ width: "100%", height: "100%" }}
						hasCollapseButton
						defaultOpenKeys={[ConsoleList[0].key]}
						selectedKeys={[ConsoleList[0].data[0].key]}
					>
						{ConsoleList.map((group) => (
							<SubMenu
								key={group.key}
								title={
									<>
										<IconFile /> {group.name}
									</>
								}
							>
								{(group.data || []).map((api) => (
									<MenuItem key={api.key}>{api.name}</MenuItem>
								))}
							</SubMenu>
						))}
					</Menu>
				</div>

				<div className="console-content">
					<UserKeyManager />
				</div>
			</div>
		</div>
	);
};

export default ConsolePage;
